import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filterBrzh'
  })
  export class FilterBrzh implements PipeTransform {
      transform(items: any[], term): any {
          return term 
              ? items.filter(item => item.id.indexOf(term) !== -1)
              : items;
      }
  }

@Pipe({
  name: 'filterDatum'
})
export class FilterDatumPipe implements PipeTransform {
    transform(items: any[], term): any {
        return term 
            ? items.filter(item => item.datumPrijave.indexOf(term) !== -1)
            : items;
    }
}

@Pipe({
    name: 'filterPrezime'
  })
  export class FilterPrezimePipe implements PipeTransform {
      transform(items: any[], term): any {
          return term 
              ? items.filter(item => item.prezime?(item.prezime.toLowerCase().indexOf(term.toLowerCase()) !== -1):false)
              : items;
      }
  }
  
  @Pipe({
    name: 'filterIme'
  })
  export class FilterImePipe implements PipeTransform {
      transform(items: any[], term): any {
          return term 
              ? items.filter(item => item.ime?(item.ime.toLowerCase().indexOf(term.toLowerCase()) !== -1):false)
              : items;
      }
  }

  @Pipe({
    name: 'filterKategorija'
  })
  export class FilterKategorijaPipe implements PipeTransform {
      transform(items: any[], term): any {
          return term 
              ? items.filter(item => item.idKategorije?(!term || item.idKategorije == term):false)
              : items;
      }
  }